export default (axios) => ({
  /**
   * Lоgin
   *
   * @link https://devapi.omara.sk/public/apidoc/#api-User-PostApiV1Authorizations
   * @param data
   * @returns {*}
   */
  signIn(data) {
    return axios.post("/authorizations", data);
  },

  /**
   * Register
   *
   * @link https://devapi.omara.sk/public/apidoc/#api-User-PostApiV1AuthorizationsSignUp
   * @param data
   * @returns {*}
   */
  signUp(data) {
    return axios.post("/authorizations/sign-up", data);
  },

  /**
   * Register
   *
   * @link https://devapi.omara.sk/public/apidoc/#api-User-PostApiV1AuthorizationsSocial
   * @param {Object} data
   * @param {string} data.token
   * @param {string} [data.cart_unique_id]
   * @returns {*}
   */
  socialAuth(data) {
    return axios.post("/authorizations/social", data);
  },

  /**
   * Logout
   *
   * @link https://devapi.omara.sk/public/apidoc/#api-User-DeleteApiV1Authorizations
   * @returns {*}
   */
  signOut() {
    return axios.delete("/authorizations");
  },
});
